import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from '@/util/SBAPI';
import { isAxiosError, AxiosErrorHandler } from '@/util/AxiosErrorHandler';
import { SBMailAuthenticationResponse } from '@/components/SBMailAuthentication';

@Component({
    components: AllComponents(),
})
export default class Email extends Mixins(CommonView) {
    type: "SELECT" | "CHANGE" | "STOP" = "SELECT";
    mode: number = 0;
    kurukuru: boolean = false;
    error: string = "";
    email: string = "";
    code: string = "";
    user: SBAPI.User = SBAPI.user();
    a: boolean = true;

    public async created() {
        if (await this.isLoginRedirect(true)) return;
    }

    public backRedirect() {
        this.type = 'SELECT'
    }

    public async check() {
        //バリデーションチェック
        this.mode = 1;
    }

    public async ok(val: SBMailAuthenticationResponse) {
        this.kurukuru = true;

        let profile = await SBAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(profile)) {
            this.error = "" + profile.data;
            return;
        }
        let user = profile.data;
        user.email = val.email;
        user.code = val.code;
        let res = await SBAPI.UserController.putUserUsingPUT(user).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
        } else {
            this.mode = 1;
        }
        this.kurukuru = false;
    }

    public async stopMode() {
        let response = await SBAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
        } else {
            response.data.email = "";
            response.data.ngMailFlag = !response.data.ngMailFlag;
            this.user = response.data;
        }
        this.type = 'STOP';
    }

    public async put() {
        this.kurukuru = true;
        this.mode = 1;
        this.user.ngMailFlag = !this.user.ngMailFlag;
        let res = await SBAPI.UserController.putUserUsingPUT(this.user).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
            return;
        }
        this.kurukuru = false;
    }
}
